/******************************************************************************\
 * File: Download.jsx
 *
 * Author: Gigster
 *
 * Description:
 *
 * Notes:
 \******************************************************************************/

//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import * as style from '@/style/common/icons/Icon.scss';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Download extends React.Component {
    render() {
        const { className, onClick } = this.props;

        const cn = classNames(style.Icon, {
            [style['clickable']]: onClick,
            [style['no-fill']]: true,
            [className]: !!className
        });

        return (
            <svg width="14px" height="16px" viewBox="0 0 14 16">
                <title>0D79BC55-1273-4DC4-B9D4-77F800FA4107@1.00x</title>
                <g
                    id="GPX-Import"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g
                        id="GPX-Import---disabled-hover-and-modal"
                        transform="translate(-973.000000, -931.000000)"
                        fill="#FFFFFF"
                    >
                        <g
                            id="footer"
                            transform="translate(0.000000, 908.000000)"
                        >
                            <g
                                id="export-gpx"
                                transform="translate(972.000000, 22.000000)"
                            >
                                <g
                                    id="Icon/Download"
                                    transform="translate(0.000000, 1.000000)"
                                >
                                    <path
                                        d="M14,10 C14.5522847,10 15,10.4477153 15,11 L15,13 C15,14.2886644 13.9553311,15.3333333 12.6666667,15.3333333 L3.33333333,15.3333333 C2.04466892,15.3333333 1,14.2886644 1,13 L1,11 C1,10.4477153 1.44771525,10 2,10 C2.55228475,10 3,10.4477153 3,11 L3,13 C3,13.1840949 3.14923842,13.3333333 3.33333333,13.3333333 L12.6666667,13.3333333 C12.8507616,13.3333333 13,13.1840949 13,13 L13,11 C13,10.4477153 13.4477153,10 14,10 Z M8,-3.64153152e-14 C8.55228475,-3.64153152e-14 9,0.44771525 9,1 L9,7.918 L9.95955989,6.95955989 C10.3500842,6.56903559 10.9832492,6.56903559 11.3737734,6.95955989 C11.7642977,7.35008418 11.7642977,7.98324916 11.3737734,8.37377345 L8.70710678,11.0404401 C8.67864047,11.0689064 8.64846592,11.0956645 8.61675008,11.1205474 L8.70710678,11.0404401 C8.67171273,11.0758342 8.63432558,11.1080204 8.59530661,11.1369988 C8.57113069,11.1548432 8.54627495,11.1716146 8.52066019,11.1872659 C8.50861311,11.1947264 8.49639444,11.2018345 8.4840621,11.2086622 C8.46366225,11.2198897 8.44260107,11.2306146 8.42112616,11.2405995 C8.40701252,11.247186 8.39270329,11.2534199 8.37828453,11.2593032 C8.35638679,11.2682588 8.33423756,11.2764111 8.31173641,11.2837867 C8.29422262,11.2894658 8.27616966,11.2948166 8.2580072,11.2996478 C8.24027414,11.3044498 8.22259565,11.3086404 8.20474263,11.312355 C8.18608079,11.316151 8.16730628,11.3195026 8.14846687,11.3223155 C8.12811445,11.3254274 8.10705742,11.3278974 8.08581099,11.329703 C8.06792309,11.3311884 8.05059097,11.3322106 8.03324678,11.3327839 C8.02240189,11.3331485 8.01122253,11.3333333 8,11.3333333 L7.96774538,11.3328163 C7.94973363,11.3322386 7.93173451,11.3311769 7.9137692,11.3296313 L8,11.3333333 C7.94937972,11.3333333 7.89963791,11.3295721 7.85103878,11.322314 C7.83269372,11.3195026 7.81391921,11.316151 7.79523446,11.3122609 C7.77740435,11.3086404 7.75972586,11.3044498 7.74223577,11.2997971 C7.72383034,11.2948166 7.70577738,11.2894658 7.68785748,11.2835952 C7.66576244,11.2764111 7.64361321,11.2682588 7.62184761,11.2593614 C7.60729671,11.2534199 7.59298748,11.247186 7.57880084,11.2406014 C7.55739893,11.2306146 7.53633775,11.2198897 7.51572305,11.2084576 C7.50360556,11.2018345 7.49138689,11.1947264 7.47929125,11.1873379 C7.45372505,11.1716146 7.42886931,11.1548432 7.4048407,11.1370198 C7.39739696,11.1315799 7.39015759,11.1260489 7.38297765,11.1204056 C7.35153408,11.0956645 7.32135953,11.0689064 7.29289322,11.0404401 L4.62622655,8.37377345 C4.23570226,7.98324916 4.23570226,7.35008418 4.62622655,6.95955989 C5.01675084,6.56903559 5.64991582,6.56903559 6.04044011,6.95955989 L7,7.919 L7,1 C7,0.44771525 7.44771525,-3.64153152e-14 8,-3.64153152e-14 Z"
                                        id="download"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        );
    }
}
export default Download;
